import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomSessionTimeoutService } from './session-timeout.service';

/**
 * CustomSessionTimeoutComponent performs basic session logout and management.
 */
@Component({
  selector: 'bb-session-timeout-modal',
  templateUrl: './session-timeout.component.html',
  providers: [CustomSessionTimeoutService],
})
export class CustomSessionTimeoutComponent implements OnInit {

  totalTime = 300; 
  secondCountdownStart = 60;  
  
  remainingTime: number;
  secondRemainingTime: number;
  intervalId: any;

  isOpen = false;

  /**
   * The options for the modal
   */
  readonly modalOptions: NgbModalOptions = {
    keyboard: false,
    backdrop: 'static',
    windowClass: 'session-timeout__modal',
    backdropClass: 'session-timeout__modal',
  };

  @HostListener('document:click', ['$event'])
  documentClick(event: any): void {
    if(this.isOpen === false) {
      this.refresh();
    }
  }

  
  /**
   * CustomSessionTimeoutComponent constructor
   * @param sessionTimeoutService Factory that allows calls to web sdk endpoints for controlling session
   * @param cd Change Detector Ref factory
   */
  constructor(
    private readonly sessionTimeoutService: CustomSessionTimeoutService,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isOpen = false;
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startCountdown(): void {
    this.remainingTime = this.totalTime;
    this.secondRemainingTime = this.secondCountdownStart;

    this.intervalId = setInterval(() => {
      if(!this.isOpen && this.remainingTime === this.secondRemainingTime) {
        this.isOpen = true;
      }
      if (this.remainingTime > 0) {
        this.remainingTime--;
        if(this.isOpen) {
          this.secondRemainingTime--;
          console.log(this.secondRemainingTime)
        }
      } else {
        console.log("onCountdownComplete")
        clearInterval(this.intervalId);
        this.onCountdownComplete();
      }
      this.cd.detectChanges();
    }, 1000);
  }

  resetCountdown(): void {
    this.isOpen = false;
    this.clearInterval();
    this.startCountdown();
  }

  clearInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  onCountdownComplete(): void {
    this.logout();
  }


  logout() {
    return this.sessionTimeoutService.logout().then(() => this.goToLoginPage());
  }

  private goToLoginPage() {
    this.sessionTimeoutService.goToLoginPage();
  }

  public refresh() {
    this.resetCountdown();
    this.sessionTimeoutService.refresh();
  }
}
